export enum WidgetScene {
  INCOMING_CALL = "incoming-call",
  CHOICE = "choice",
  LOADING = "LOADING",
  CALL = "CALL",
  CHAT = "CHAT",
}
